<template>
  <div v-if="termsForm.length > 0" class="page-container">
    <section class="mb-3">
      <v-checkbox
        v-model="agreeAll"
        hide-details
        class="mt-0 pt-0"
        @click="toggleAgreeAll(agreeAll)"
      >
        <template v-slot:label>
          <div class="color--nice-black">전체 동의</div>
        </template>
      </v-checkbox>
    </section>
  

    <v-divider class="color--gray-text mb-2" />

    <section>
      <!-- 필수 약관 시작 -->
      <v-checkbox
        v-for="{ $model: terms } in $v.termsForm.$each.$iter"
        :key="terms.uuid"
        v-model="terms.isAgreed"
        hide-details
        @click="checkAgreeAll"
        class="mt-0 mb-1"
      >

        <template #label>
          <p class="mb-0 width-100">
            <span class="color--nice">(필수)</span>
            {{ terms.title }}
          </p>
        </template>
        <template #append>
          <a :href="terms.link" target="_blank" rel="noopener noreferrer">
            <v-icon class="color--gray-50">mdi-chevron-right</v-icon>
          </a>

        </template>
        

      </v-checkbox>
     
    </section>
  </div>
  
</template>



<script>
import { sameAs } from 'vuelidate/lib/validators'
import { additionalTerms } from './terms'
import { mapActions, mapState } from 'vuex'  //sean
import { simpleClone } from '@/util'


export default {
  props: {
    valid: {
      type: Boolean,
    },
    terms: {
      type: Array,
    },
  },
  data() {
    return {
      additionalTerms: simpleClone(additionalTerms),
      fetchedTerms: null,

      agreeAll: false,
      showDetails: {},
      //termsAgreedState: false,
    }
  },
  validations: {
    termsForm: {
      $each: {
        isAgreed: {
          sameAs: sameAs(() => true),
        },
      },
    },
    
  },
  watch: {
    invalid(v, oldVal) {
      //console.log('INVALID@!!!!!', v)

      this.$emit('update:valid', !v)
      this.$emit(
        'update:terms',
        // 하드코딩된 번개입금 서비스 약관 제외
        this.termsForm.filter((e) => e.code !== 'SERVICE1'),
      )
    },
  },
  computed: {
    ...mapState('myfinbiz', ['organization']),
    invalid(){
      /*

      const allAgreed = this.termsAgreedState;
      const invalidFlag = this.$v.requiredTermsOrganization.$invalid || this.$v.requiredTermsFin.$invalid
      console.log('COMPUTED', invalidFlag)
      console.log(this.$v.requiredTermsOrganization.$invalid)
      console.log(this.$v.requiredTermsFin.$invalid)
        return invalidFlag
        */

        const allAgreed = this.agreeAll;

        const allAgreedEach = this.termsForm.every( term => term.isAgreed )
   
        const invalidFlag = !allAgreedEach;
        //console.log('COMPUTED', invalidFlag, allOrganizationAgreed, allFinAgreed)

       return invalidFlag;
    },
    termsForm() {
      if (!this.fetchedTerms) return []

      //console.log(this.fetchedTerms)

      let terms = []
      //terms = terms.concat(this.additionalTerms)
      terms = terms.concat(this.fetchedTerms)

      return terms
    },
    
  },
  async created() {
    console.log('CREATED!!!!')


    this.fetchedTerms = await this.getKcsTerms()

    console.log('fetchedTerms : ', this.fetchedTerms)
  },
  methods: {
    ...mapActions('agreement', ['getKcsTerms']),
    checkAgreeAll() {
      // 전체 체크면 체크 - 전체 해제면 해제
      if (this.termsForm.every((e) => e.isAgreed === true)) {
        this.agreeAll = true

        //console.log('모든 체크박스!!!')
        //this.termsAgreedState = true;

        return
      }
      this.agreeAll = false
    },

    toggleAgreeAll(flag) {
      //console.log('toggleAgreeAll : ', flag)
      for (const terms of this.termsForm) {
        terms.isAgreed = flag

      }

      this.agreeAll = flag;
      //console.log('TOGGLE AGREE ALL', this.requiredTermsOrganization, this.requiredTermsFin)
      //this.invalid = !flag;
      //this.termsAgreedState = flag;




    },


    toggleDetails(uuid) {
      if (this.showDetails[uuid] === undefined) {
        this.$set(this.showDetails, uuid, true);
      } else {
        this.$set(this.showDetails, uuid, !this.showDetails[uuid]);
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
  opacity: 0;
}
::v-deep .v-input {
  &__slot label {
    font-size: 0.875rem;
  }
  &__append-outer {
    margin-left: 0 !important;
  }
}
p {
  font-size: 0.875rem;
  line-height: 1.3;
  letter-spacing: -0.2px;
}
</style>
